import React from 'react';

type Props = { date: string };

export function CardDate({ date }: Props) {
    const dateObject = new Date(date);

    return (
        <div className="flex flex-col w-full">
            <span className="text-base font-semibold">
                {dateObject.toLocaleString('fr-FR', { day: 'numeric', month: 'short' })}
            </span>
            <span className="text-sm font-normal">
                {dateObject.toLocaleString('fr-FR', { year: 'numeric' })}
            </span>
        </div>
    );
}
